import { serializable, alias, primitive } from 'serializr';

export class TicketsModelForDashboard {
	@serializable(alias('ticket_status', primitive()))
	ticketStatus?: 'Active' | 'Closed'| 'Re-opened';

	@serializable(alias('total', primitive()))
	total?: number;
}
